import { useLocation } from 'react-router-dom';
import { Dashicon } from '@wordpress/components';
import {__} from '@wordpress/i18n';

export default function Breadcrumbs() {

    const location = useLocation();
     const pathMap = {
        '/header': 'Header',
        '/footer': 'Footer',
        '/404': '404',
        '/new': 'Create New',
    };

    const page = pathMap[location.pathname] || __( 'All Layouts', 'responsive-addons' );

    const backToDashboard = () => {
        window.location.href = responsive_addons_site_builder.admin_url;
    }

    return (
        <>
            <span className="text-white text-sm font-medium cursor-pointer" onClick={backToDashboard} >{__( 'Dashboard', 'responsive-addons' )}</span>
            <Dashicon icon="arrow-right-alt2" className="text-white" size={12} />
            <span className="text-white text-sm font-medium">{__( 'Responsive', 'responsive-addons' )}</span>
            <Dashicon icon="arrow-right-alt2" className="text-white" size={12} />
            <span className="text-white text-sm font-medium">{__( 'Site Builder', 'responsive-addons' )}</span>
            <Dashicon icon="arrow-right-alt2" className="text-white" size={12} />
            <span className="text-white text-sm font-medium">{page}</span>
        </>
    )
}